import { render, staticRenderFns } from "./GamificationAll.vue?vue&type=template&id=20e86951&scoped=true"
import script from "./GamificationAll.vue?vue&type=script&lang=js"
export * from "./GamificationAll.vue?vue&type=script&lang=js"
import style0 from "./GamificationAll.vue?vue&type=style&index=0&id=20e86951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e86951",
  null
  
)

export default component.exports